export default {
  state: {
    userData: {},
    auth: false,
  },
  getters: {
    getUser: (state) => {
      return state.userData;
    },
    getAuth: (state) => {
      return state.auth;
    },
  },
  mutations: {
    setUser: (state, payload) => {
      state.userData = payload;
    },
    setAuth: (state, payload) => {
      state.auth = payload;
    },
  },
};
